module.exports = __webpack_public_path__ + "static/img/weimoke.a196bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/coopera/images/weimoke.png
// module id = gII8
// module chunks = 1